/**
 * Converts a File object to a WebP Blob with 0.8 quality.
 * Preserves transparency.
 */
export const convertImageToWebP = async (
  file: File,
): Promise<{ blob: Blob; fileName: string }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          reject(new Error('Could not get canvas context'))
          return
        }

        // Draw image directly - explicit clearing is good practice but new canvas is transparent by default
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0)

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const fileName = file.name.replace(/\.[^/.]+$/, '') + '.webp'
              resolve({ blob, fileName })
            } else {
              reject(new Error('Canvas to Blob conversion failed'))
            }
          },
          'image/webp',
          0.8,
        )
      }
      img.onerror = (error) => reject(error)
      img.src = event.target?.result as string
    }
    reader.onerror = (error) => reject(error)
    reader.readAsDataURL(file)
  })
}
